module.exports = __webpack_public_path__ + "img/location.d77efafd.jpg";